import { render } from "./PageBanner.vue?vue&type=template&id=9032373e&scoped=true&ts=true"
import script from "./PageBanner.vue?vue&type=script&lang=ts"
export * from "./PageBanner.vue?vue&type=script&lang=ts"

import "./PageBanner.vue?vue&type=style&index=0&id=9032373e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9032373e"]])

export default __exports__